<template lang="pug">
.opened-coupon-block
  locked-coupon-tab(v-for="(item, index) in ladderPropGroupList"
                    :ladderDetailMap="ladderDetailMap" :info="item"
                    v-if="index === 0 || (isOpenFlag&& index !==0) || (version === 'ladder_blend'|| version ==='ladder_blend_two')"
                    @clickReceive="(couponInfo)=> {$emit('clickReceiveButton',couponInfo)}"
                    @notInAppJump="() =>{$emit('notInAppJump')}"
                    :noBorderFlag="index === noBorderIndex")
  .more-block(@click="changeOpenFlag()" v-if="!isOpenFlag && (version !== 'ladder_blend'&& version!=='ladder_blend_two')")
    .more-coupons-bar
      .more-text 查看更多
      img.more-icon(src="https://m.hellobike.com/resource/helloyun/22042/FtlPpVNDAq.png?x-oss-process=image/quality,q_80")
</template>

<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import freeCouponTab from './free-coupon-tab';
import lockedCouponTab from './locked-coupon-tab.vue';

export default {
  components: {
    Lottie,
    freeCouponTab,
    lockedCouponTab,
  },
  props: {
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpenFlag: false,
    };
  },
  inject: ['getPropVersion'],

  computed: {
    version() {
      if (this.getPropVersion) {
        return this.getPropVersion();
      }
      return '';
    },
    noBorderIndex() {
      return this.isOpenFlag ? (this.ladderPropGroupList.length - 1) : 0;
    },
  },
  mounted() {
    this.goBizUBT();
  },
  methods: {
    goBizUBT() {
      const valueArray = Object.values(this.ladderDetailMap);
      if (valueArray.length) {
        if (valueArray[0].appJumpUrl) {
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_copuon_daoliu',
            contentId: 'platform_copuon_daoliu',
            exposureTimes: 1,
            businessInfo: {
              BusinessLine: '0',
            },
          });
        }
      }
    },
    changeOpenFlag() {
      this.$emit('open');
      this.isOpenFlag = true;
    },
  },
};
</script>
<style lang="less" scoped>
.opened-coupon-block {
  .title-line {
    align-items: center;
    display: flex;
    height: 0.22rem;
    margin-bottom: 0.14rem;

    .title-line-number {
      width: 0.22rem;
      height: 0.22rem;
    }

    .title-line-text {
      margin-left: 0.04rem;
      height: 0.22rem;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 0.22rem;
    }
  }

  .more-block {
    padding-bottom: 0.14rem;

    .more-coupons-bar {
      margin: -0.08rem auto 0 auto;
      // margin: 0 auto;
      width: 0.88rem;
      height: 0.29rem;
      background: #f7f7f7;
      border-radius: 0.16rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .more-text {
        width: fit-content;
        height: 0.17rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #5a6066;
        line-height: 0.17rem;
      }

      .more-icon {
        width: 0.14rem;
        height: 0.14rem;
        margin-left: 0.01rem;
      }
    }
  }
}
// .opened-coupon-block .locked-single-coupon-tab:last-of-type {
//   border: none;
// }
</style>
